var thewrongshop;
(function($) {
  "use strict";
  thewrongshop = (function() {
    return {
      init: function() {
        // Header
        this.announcement();
        this.fixedHeader();
        this.headerNav();
        this.headerRight();
        this.headerSearch();
        this.headerCart();
        this.account();
        this.mobileMenu();

        // Home
        this.productFeed();
        this.categories();
        this.artists();

        // Collection
        this.collection();
        this.collectionFilter();

        // Product
        this.productImages();
        this.productImagesNew();
        this.productArtistInformation();
        this.productReviews();
        this.productDetails();
        this.productForm();
        this.productFormNew();
        this.productFramingGuide();

        // Pages
        this.pageDelivery();
        this.blog();
        this.article();
        this.about();
        this.framing();
        this.contactForm();

        // Utilites
        this.matchHeight();
        this.video();
        this.aos();
        this.zoom();
        this.gallery();
        this.accordion();
        this.videoLightbox();
        this.upsellCart();
      },

      // Header
      announcement: function() {
        if(localStorage.getItem('country2') !== null && localStorage.getItem('timezone2') !== null) {
          var country = 'row'; 
          var timezone = localStorage.getItem('timezone2');
          if(timezone.indexOf("Europe") >= 0) {
            country = 'eu';
          }
          if(localStorage.getItem('country2') == 'GB') {
            country = 'uk';
          }
          if(localStorage.getItem('country2') == 'US') {
            country = 'us';
          }
          $(".js-announcement-item:not(.show-for-" + country + ")").remove();
          $(".js-header-announcement").addClass("active");

          // Delivery message
          $(".js-delivery-message:not(.show-for-" + country + ")").remove();
          $(".js-delivery-message").show();

          // Product announcement
          $(".js-product-announcement-item:not(.show-for-" + country + ")").remove();
          $(".js-product-announcement-carousel").owlCarousel({
            loop: true,
            margin: 15,
            nav: false,
            items: 1,
            dots: true,
            autoplay: true
          }); 
        } else {
          $.get("https://ipinfo.io", function(response) {
            var country = 'row';
            if(response.timezone.indexOf("Europe") >= 0) {
              country = 'eu';
            }
            if(response.country == 'GB') {
              country = 'uk';
            }
            if(response.country == 'US') {
              country = 'us';
            }
            $(".js-announcement-item:not(.show-for-" + country + ")").remove();
            $(".js-header-announcement").addClass("active");
            localStorage.setItem('country2', response.country);
            localStorage.setItem('timezone2', response.timezone);

            // Delivery message
            $(".js-delivery-message:not(.show-for-" + country + ")").remove();
            $(".js-delivery-message").show();

            // Product announcement
            $(".js-product-announcement-item:not(.show-for-" + country + ")").remove();
            $(".js-product-announcement-carousel").owlCarousel({
              loop: true,
              margin: 15,
              nav: false,
              items: 1,
              dots: true,
              autoplay: true
            }); 
          }, "jsonp");
        }
      },

      fixedHeader: function() {
        $(window).scroll(function() {
          if($(".js-page-artist-directory").length > 0) {
            var scrollTop = $(window).scrollTop();
            if(scrollTop > 300) { 
              $(".js-header").addClass("home-fixed-header");
            } else {
              $(".js-header").removeClass("home-fixed-header");
            }
          } else {
            var scrollTop = $(window).scrollTop() + 420;
            if(scrollTop > $(window).outerHeight()) { 
              $(".js-header").addClass("home-fixed-header");
            } else {
              $(".js-header").removeClass("home-fixed-header");
            }
          }
        });
      },

      headerNav: function() {
        $(".js-header-nav-item").hover(function () {
          var positionLeftMenu = $(".js-header-menu").offset().left;
          var positionItemLeft = $(this).offset().left;
          var difference = positionItemLeft - positionLeftMenu;
          var width = $(this).outerWidth() + 12;
          $(".js-header-nav-background-hover").css("left", difference).css("width", width);
        });
        var turnOffBackground = false;
        $(".js-header-menu").hover(function () {
          setTimeout(function () {
            $(".js-header-nav-background-hover").addClass("active");
          }, 100);
          clearTimeout(turnOffBackground);
        }, function () {
          turnOffBackground = setTimeout(function () {
            $(".js-header-nav-background-hover").removeClass("active");
          }, 1000);
        });
        $(".js-change-dropdown-hover-image").hover(function () {
          $(this).closest(".js-header-nav-item").find(".js-dropdown-hover-image").attr("src", $(this).attr("data-image-src"));
        });
      },

      headerRight: function() {
        $(".js-header-right-item").hover(function () {
          var positionLeftMenu = $(".js-header-right").offset().left;
          var positionItemLeft = $(this).offset().left;
          var difference = positionItemLeft - positionLeftMenu;
          var width = $(this).outerWidth();
          $(".js-header-right-background-hover").css("left", difference).css("width", width);
        });
        var turnOffBackground2 = false;
        $(".js-header-right").hover(function () {
          setTimeout(function () {
            $(".js-header-right-background-hover").addClass("active");
          }, 100);
          clearTimeout(turnOffBackground2);
        }, function () {
          turnOffBackground2 = setTimeout(function () {
            $(".js-header-right-background-hover").removeClass("active");
          }, 1000);
        });
      },

      headerSearch: function() {
        $(".js-open-search").click(function () {
          $(this).toggleClass("active");
          $(".js-search").toggleClass("active");
          $(".js-header-for-search").toggleClass("home-header-with-search");
          setTimeout(function () {
            $(".js-search.active .js-search-input").focus();
          }, 300);
          return false;
        });
      },

      headerCart: function() {
        Shopify.Products.showRecentlyViewed( { howManyToShow: 9 } );
        setTimeout(function () {
          $(".js-mobile-recently-viewed").html($(".js-recently-viewed").html());
        }, 1500);
        $(".js-open-cart").click(function () {
          $("body").css("overflow", "hidden");
          $(".js-canvas-cart").addClass("active");
          setTimeout(function () {
            $(".js-canvas-cart").addClass("show");
          }, 100);
          return false;
        });
        $("body").on("click", ".js-close-canvas-cart, .js-continue-shopping", function() {
          $(".js-canvas-cart").removeClass("active");
          $(".js-canvas-cart").removeClass("show");
          $("body").css("overflow", "visible");
          return false;
        });
        $("body").on("click", ".js-change-quantity", function() {
          var variantId = parseInt($(this).attr("data-variant-id"));
          var quantity = parseInt($(this).attr("data-quantity"));
          $(".js-cart-content").addClass("is-loading");
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: variantId, quantity: quantity },
            success: function() {
              thewrongshop.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              thewrongshop.refreshCart();
            }
          });
          return false;
        });
      },

      account: function() {
        $(".js-toggle-account").click(function () {
          $(".js-login").toggleClass("active");
          setTimeout(function () {
            $(".js-login").toggleClass("show");
          }, 100);
          return false;
        });
        $(".js-go-to-canvas-forgotten-password").click(function () {
          $(".js-login-canvas-login").addClass("d-none");
          $(".js-login-canvas-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login-canvas").click(function () {
          $(".js-login-canvas-login").removeClass("d-none");
          $(".js-login-canvas-forgotten-password").addClass("d-none");
          $(".js-login-canvas-register").addClass("d-none")
          return false;
        });
        $(".js-go-to-canvas-register").click(function () {
          $(".js-login-canvas-login").addClass("d-none");
          $(".js-login-canvas-forgotten-password").addClass("d-none");
          $(".js-login-canvas-register").removeClass("d-none")
          return false;
        });
        $(".js-go-to-forgotten-password").click(function () {
          $(".js-login-login").addClass("d-none");
          $(".js-login-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login").click(function () {
          $(".js-login-login").removeClass("d-none");
          $(".js-login-forgotten-password").addClass("d-none");
          return false;
        });
      },

      mobileMenu: function() {
        $(".js-open-mobile-menu").click(function () {
          if($(".js-mobile-menu").hasClass("active")) {
            $(".js-header-for-search").removeClass("active-mobile-menu");
            $(".js-mobile-menu").removeClass("active");
          } else {
            $(".js-header-for-search").addClass("active-mobile-menu");
            $(".js-mobile-menu").addClass("active");
          }
          $(".js-search").removeClass("active");
          $(".js-header-for-search").removeClass("home-header-with-search");
          return false;
        });
        $(".js-open-mobile-search").click(function () {
          $(".js-header-for-search").removeClass("active-mobile-menu");
          $(".js-mobile-menu").removeClass("active");
          $(".js-search").addClass("active");
          $(".js-header-for-search").addClass("home-header-with-search");
          setTimeout(function () {
            $(".js-search.active .js-search-input").focus();
          }, 300);
          return false;
        });
        $(".js-mobile-menu-carousel").owlCarousel({
          loop: false,
          margin: 15,
          nav: false,
          items: 1,
          dots: false,
          autoplay: false
        }); 
        $(".js-go-to-mobile-second-menu").click(function () {
          var id = $(this).attr("data-id");
          $(".js-mobile-menu-second-step").addClass("d-none");
          $(".js-mobile-menu-second-step[data-id='" + id + "']").removeClass("d-none");
          $(".js-mobile-menu-carousel").trigger('to.owl.carousel', 1);
          return false;
        });
        $(".js-go-to-first-step-mobile-menu").click(function () {
          $(".js-mobile-menu-carousel").trigger('to.owl.carousel', 0);
          return false;
        });
      },

      // Home
      productFeed: function() {
        $(".js-product-tab").click(function () {
          $(".js-product-tab").removeClass("active");
          $(this).addClass("active");
          var id = $(this).attr("data-id");
          $(".js-product-tab-content").removeClass("active").removeClass("show");
          $(".js-product-tab-content[data-id='" + id + "']").addClass("active");
          setTimeout(function () {
            $(".js-product-tab-content[data-id='" + id + "']").addClass("show");
          }, 100);
          return false;
        });
        $(".js-product-feed-carousel").owlCarousel({
          loop: false,
          margin: 113,
          nav: true,
          items: 3,
          dots: false,
          autoplay: false,
          responsive: {
            0:{
              items: 1,
              margin: 27
            }, 
            768:{
              items: 2,
              margin: 27
            },
            992: {
              items: 3,
              margin: 60
            },
            1099: {
              margin: 80,
              items: 3
            },
            1340: {
              margin: 113,
              items: 3
            }
          }
        });  
      },

      categories: function() {
        $(".js-category-title").bind("mousemove", function(e) {
          var positionLeft = $(this).offset().left;
          var positionTop = $(this).offset().top;
          var mousePositionLeft = e.pageX;
          var mousePositionTop = e.pageY;
          var top = mousePositionTop - positionTop;
          var left = mousePositionLeft - positionLeft;
          $(this).closest(".js-category").find(".js-category-image").css("top", top).css("left", left);
        });
        $(".js-categories-carousel").owlCarousel({
          loop: true,
          margin: 15,
          nav: false,
          items: 1,
          dots: false,
          autoplay: false
        }); 
      },

      artists: function() {
        $(".js-artist").hover(function () {
          $(".js-artist").addClass("unactive");
          $(this).removeClass("unactive").addClass("active");
          var id = $(this).attr("data-id");
          $(".js-artist-image").removeClass("active");
          $(".js-artist-image[data-id='" + id + "']").addClass("active");
          $(".js-artists-images").addClass("active");
        }, function () {
          $(".js-artist").removeClass("unactive");
          /* $(".js-artist-image").removeClass("active"); */
          $(".js-artists-images").removeClass("active");
        });
      },

      // Collection
      collection: function() {
        $("body").on("click", ".js-collection-next-page", function () {
          var href = $(this).attr("href");
          $(".js-collection-next-page").html($(".js-collection-next-page").attr("data-loading-text"));
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $(".js-collection-action").remove();
            $('.js-collection-row').append($(data).find('.js-collection-row').html());
          });
          return false;
        });
      },

      collectionFilter: function() {
        Shopify.queryParams = {};
        Shopify.queryParams.sort_by = $(".js-change-sort-by.active").attr("data-value");
        var tags = [];
        $("input.tag").each(function () {
          if($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        Shopify.queryParams.constraint = tags.join("+");

        function filterCreateUrl() {
          if($(".js-collection-items").hasClass("search2")) {
            return $(".js-collection-items").attr("data-url") + "&sort_by=" + Shopify.queryParams.sort_by;
          } else {
            if(Shopify.queryParams.constraint == '') {
              return $(".js-collection-items").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by;
            } else {
              return $(".js-collection-items").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by;
            }
          }
        }

        function filterGetContent(url) {
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function() {
              $(".js-collection-items").addClass("loading");
            },
            success: function(result) {
              var title = result.match("<title>(.*?)</title>")[1];
              History.pushState({
                param: Shopify.queryParams
              }, title, url);
              $(".js-collection-items").html($(result).find(".js-collection-items").html());
              $(".js-collection-items").removeClass("loading");
            },
            error: function() {
              $(".js-collection-items").removeClass("loading");
            }
          })
        }

        $("body").on("click", ".js-change-sort-by", function(y) {
          Shopify.queryParams.sort_by = $(this).attr("data-value");
          filterGetContent(filterCreateUrl());
          $(".js-change-sort-by").removeClass("active");
          $(this).addClass("active");
          return false;
        });

        $("body").on("change", ".js-change-mobile-sort-by", function(y) {
          $(".js-change-sort-by[data-index='" + $(this).val() + "']").click();
        });

        $(document).on('click', function (e) {
          if ($(e.target).closest(".js-sort").length === 0) {
            $(".js-sort-dropdown").removeClass("active");
          }
        });
        $(".js-open-sort-dropdown").click(function () {
          $(".js-sort-dropdown").toggleClass("active");
          return false;
        });

        $(".js-toggle-filter-widget").click(function() {
          $(this).parent().parent().find(".js-filter-widget").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          $(this).parent().find(".js-filter-widget-content").slideToggle(500);
        });

        $("input.tag").change(function () {
          if($(this).is(":checked")) {
            $(this).parent().parent().parent().find("input.tag").prop("checked", false);
            $(this).prop("checked", true);
          } else {
            $(this).parent().parent().parent().find("input.tag").prop("checked", false);
          }
          var tags = [];
          var counter = 0;
          $(".js-delete-filter-tag").remove();
          var htmlActiveTags = '';
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
              counter++;
              htmlActiveTags += '<a href="#" class="js-delete-filter-tag" data-value="' + $(this).attr("value") + '">' + $(this).attr("data-label") + '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.99275 6.05325L0.75 1.8105L1.8105 0.75L6.05325 4.99275L10.296 0.75L11.3565 1.8105L7.11375 6.05325L11.3565 10.296L10.296 11.3565L6.05325 7.11375L1.8105 11.3565L0.75 10.296L4.99275 6.05325Z" fill="black"/></svg></a>';
            }
          });
          $(".js-collection-active-tags").html(htmlActiveTags);
          $(".js-filter-counter").html('[' + counter + ']').attr("data-counter", counter);
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });

        $("body").on("click", ".js-delete-filter-tag", function () {
          var value = $(this).attr("data-value");
          $("input.tag[value='" + value + "']").prop('checked', false).change();
          return false;
        });

        $(".js-view-all-options").click(function () {
          $(this).closest(".js-filter-widget-options").addClass("active");
          return false;
        });

        $(".js-open-collection-filter").click(function () {
          $(".js-collection-filter").addClass("active");
          setTimeout(function () {
            $(".js-collection-filter-content").addClass("active");
          }, 10);
          return false;
        });

        $(".js-close-collection-filter").click(function () {
          $(".js-collection-filter").removeClass("active");
          $(".js-collection-filter-content").removeClass("active");
          return false;
        });
      },

      // Product
      productImages: function() {
        $(".js-main-product-images-carousel").owlCarousel({
          loop: true,
          margin: 0,
          nav: false,
          items: 2,
          dots: false,
          autoplay: false,
          responsive: {
            0:{
              items: 1,
              loop: false
            }, 
            992:{
              items: 2,
              loop: true
            }
          }
        });  
        $(".js-open-mobile-zoom").click(function () {
          $(".js-main-product-images-carousel .owl-item.active .js-mobile-popup-gallery").click();
        });
        $(".js-carousel-nav-previous").click(function () {
          $(".js-main-product-images-carousel").trigger('prev.owl.carousel');
          return false;
        });
        $(".js-carousel-nav-next").click(function () {
          $(".js-main-product-images-carousel").trigger('next.owl.carousel');
          return false;
        });
        $(".js-main-product-images-carousel").on('changed.owl.carousel', function(event) {
          if($(window).outerWidth() > 991) {
            $(".js-hide-details:not(.d-none)").click();
          }
          setTimeout(function () {
            var item = $(".js-main-product-images-carousel .owl-item.active").eq(0).find(".js-main-product-image").attr("data-new-index");
            $(".js-carousel-nav-info").html(item + ' - ' + $(".js-carousel-nav-info").attr("data-count"));
            $(".js-main-product-zommed-image").removeClass("active");
            $(".js-main-product-zommed-image[data-new-index='" + item + "']").addClass("active");
          }, 50);
        });
        $(".js-open-zoom").click(function () {
          /* $(this).addClass("active");
          return false; */
        });
        setInterval(function () {
          if($("figure.containerZoom.active").length > 0) {
            $(".js-zoomed-cursor").addClass("active");
          } else {
            $(".js-zoomed-cursor").removeClass("active");
          }
        }, 50);
        $(window).mousemove(function(e) {
          if($(".js-zoomed-cursor").length > 0) {
            $(".js-zoomed-cursor").css({
              top: e.clientY - $(".js-main-product-images-carousel").offset().top + $(window).scrollTop(),
              left: e.clientX - $(".js-main-product-images-carousel").offset().left
            });
          }
        });
        $(".js-zoomed-image-container").hover(function () {
          $(this).find(".js-zoomed-cursor").addClass("show");
        }, function () {
          $(this).find(".js-zoomed-cursor").removeClass("show");
        });
        $(".js-main-product-image").click(function () {
          $(".js-zoomed-images").addClass("active");
          $(".js-main-product-zommed-image").removeClass("active");
          var item = $(this).attr("data-new-index");
          $(".js-main-product-zommed-image[data-new-index='" + item + "']").addClass("active");
          setTimeout(function () {
            $(".js-main-product-images-carousel").trigger('to.owl.carousel', item - 1);
          }, 400);
        });
        $(".js-close-zoomed-images").click(function () {
          $(".js-zoomed-images").removeClass("active");
          return false;
        });
      },

      productImagesNew: function() {
        $(".js-desktop-popup-gallery").jqPhotoSwipe({
          forceSingleGallery: true
        });
        $(".js-mobile-popup-gallery").jqPhotoSwipe({
          forceSingleGallery: true
        }); 
        $(".js-main-product-images-carousel-new").owlCarousel({
          loop: true,
          margin: 0,
          nav: false,
          items: 1,
          dots: false,
          autoplay: false
        }); 
        $("body").on("click", ".owl-item.cloned .js-desktop-popup-gallery", function () {
          var index = $(this).closest(".js-main-product-image-new").attr("data-new-index");
          $(".owl-item:not(.cloned) div[data-new-index='" + index + "'] .js-desktop-popup-gallery").click();
          return false;
        });
        $("body").on("click", ".owl-item.cloned .js-mobile-popup-gallery", function () {
          var index = $(this).closest(".js-main-product-image-new").attr("data-new-index");
          $(".owl-item:not(.cloned) div[data-new-index='" + index + "'] .js-mobile-popup-gallery").click();
          return false;
        });
        $(".js-main-product-images-carousel-new").on('changed.owl.carousel', function(event) {
          setTimeout(function () {
            var item = $(".js-main-product-images-carousel-new .owl-item.active").eq(0).find(".js-main-product-image-new").attr("data-new-index");
            $(".js-carousel-nav-new-info").html(item + ' - ' + $(".js-carousel-nav-new-info").attr("data-count"));
          }, 50);
        });
        $(".js-carousel-nav-new-previous").click(function () {
          $(".js-main-product-images-carousel-new").trigger('prev.owl.carousel');
          return false;
        });
        $(".js-carousel-nav-new-next").click(function () {
          $(".js-main-product-images-carousel-new").trigger('next.owl.carousel');
          return false;
        });
      },

      productArtistInformation: function() {
        var name = $(".js-get-artist-information").attr("data-name");
        $(".js-get-artist-information").html($(".js-artist-information[data-name='" + name + "']").html());
        $(".js-product-artist-url").each(function () {
          var name = $(this).attr("data-artist-name");
          var url = $(".js-artist-information[data-name='" + name + "']").attr("data-url");
          if(url != '') {
            $(this).attr("href", url);
          }
        });
      },

      productReviews: function() {
        setInterval(function () {
          if($("#klaviyo-reviews-all-wrapper").length > 0) {
            $("#klaviyo-reviews-all-wrapper, #klaviyo-reviews-all").addClass("active");
          }
        }, 100);
      },

      productDetails: function() {
        $(".js-toggle-product-details").click(function () {
          $(".js-product-details").slideToggle(500);
          if(!$(this).hasClass("active")) {
            $(".js-hide-details").addClass("d-none");
            $(".js-show-details").removeClass("d-none");
          } else {
            $(".js-hide-details").removeClass("d-none");
            $(".js-show-details").addClass("d-none");
          }
          $(this).toggleClass("active");
          return false;
        });
      },

      productForm: function() {
        function variants(productId) {
          var data = JSON.parse(document.getElementById('ProductJson' + productId + '').innerHTML);
          var selectCallback = function(variant, selector) {
            var that = $(".js-product[data-product-id='" + productId + "']");
            if (variant) {
              if (variant.available) {
                $(that).find(".js-product-add-to-cart").removeClass("d-none");
                $(that).find(".js-product-out-of-stock").addClass("d-none");
              } else {
                $(that).find(".js-product-add-to-cart").addClass("d-none");
                $(that).find(".js-product-out-of-stock").removeClass("d-none");
              }
              
              if(variant.featured_image !== null) {
                var position = variant.featured_image.position;
                var new_position = $(".js-main-product-image[data-index='" + position + "']").attr("data-new-index");
                if($(".js-main-product-images-carousel").length > 0) {
                  $(".js-main-product-images-carousel").trigger('to.owl.carousel', new_position - 1);
                }
                var new_position_new = $(".js-main-product-image-new[data-index='" + position + "']").attr("data-new-index");
                if($(".js-main-product-images-carousel-new").length > 0) {
                  $(".js-main-product-images-carousel-new").trigger('to.owl.carousel', new_position_new - 1);
                }
              } 
             
              $(".js-product-upsell").addClass("d-none");
              if($(".js-product-upsell[data-variant-id='" + variant.id + "']").length > 0) {
                $(".js-product-upsell[data-variant-id='" + variant.id + "']").removeClass("d-none");
                $(".js-product-upsell[data-variant-id='" + variant.id + "']").find(".js-product-upsell-carousel").owlCarousel({
                  loop: false,
                  margin: 20,
                  nav: true,
                  items: 2,
                  dots: false,
                  autoplay: false,
                  responsive: {
                    0:{
                      items: 1,
                      margin: 10
                    }, 
                    768:{
                      items: 2,
                      margin: 10
                    }, 
                    992:{
                      items: 1,
                      margin: 20
                    }, 
                    1199:{
                      items: 2,
                      margin: 20
                    }
                  }
                });
              }
            } else {
              $(that).find(".js-product-add-to-cart").addClass("d-none");
              $(that).find(".js-product-out-of-stock").removeClass("d-none");
            }
          }
          jQuery(function($) {
            if($("#product-select-" + productId + "").length > 0) {
              new Shopify.OptionSelectors("product-select-" + productId + "", { product: data , onVariantSelected: selectCallback });
            }
          });
        }

        $(".js-product-out-of-stock .second-button").click(function () {
          $("body > div > button.needsclick").click();
          return false;
        });

        $(".js-product").each(function () {
          variants($(this).attr("data-product-id"));
        });

        $(".js-change-product-option").click(function () {
          $(this).parent().parent().find("li").removeClass("active");
          $(this).parent().addClass("active");
          var option = $(this).parent().parent().attr("data-option");
          var value = $(this).attr("data-value");
          var productId = $(this).attr("data-product-id");
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          var id = $(this).closest(".js-modal-product-option").attr("data-option-id");
          if(value.indexOf('£') == -1) {
            $(".js-open-product-option[data-option-id='" + id + "']").find(".js-product-option-value").html(value);
          }
          var that = $(this);
          $(this).closest(".js-modal-product-option").removeClass("active");
          setTimeout(function () {
            $(that).closest(".js-modal-product-option").removeClass("show");
          }, 300);
          return false;
        });

        $(".js-close-product-modal-option").click(function () {
          var that = $(this);
          $(this).closest(".js-modal-product-option").removeClass("active");
          setTimeout(function () {
            $(that).closest(".js-modal-product-option").removeClass("show");
          }, 300);
          return false;
        });

        $(".js-open-product-option").click(function () {
          var id = $(this).attr("data-option-id");
          $(".js-modal-product-option").removeClass("active").removeClass("show");
          $(".js-modal-product-option[data-option-id='" + id + "']").addClass("show");
          setTimeout(function () {
            $(".js-modal-product-option[data-option-id='" + id + "']").addClass("active");
          }, 50);
          return false;
        });

        $("body").on("click", ".js-add-to-cart", function () {
          $(this).html($(this).attr("data-adding-text"));
          var productId = $(this).attr("data-product-id");
          var quantity = 1;
          var id = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + "").val();
          var items = [];
          var variantTitle = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + " option:selected").text();
          $(".js-automatically-added-product").each(function () {
            if($(this).attr("data-for-product") == id || $(this).attr("data-for-variant") == variantTitle) {
              var product = {'id': $(this).attr("data-add-product"), 'quantity': quantity};
              items.push(product);
            }
          })
          if(items.length > 0) {
            id = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + " option:first-child").attr("value");
          }
          var newItem = {'id': id, 'quantity': quantity};
          items.push(newItem);
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { items: items },
            success: function() {
              thewrongshop.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              thewrongshop.refreshCart();
            }
          });
          return false;
        });
      },

      productFormNew: function() {
        $(".js-product-option").click(function () {
          if(!$(this).hasClass("current")) {
            $('.js-product-option').removeClass('current');
            $(this).addClass("current");

            var option = $(this).closest('[data-option]').attr("data-option");
            var value = $(this).attr("data-value");
            var productId = $(this).attr("data-product-id");
            $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          }
        });
        $("body").on("click", ".js-add-variant-to-cart", function () {
          $(this).html($(this).attr("data-adding-text"));
          var variantId = parseInt($(this).attr("data-variant-id"));
          var items = [];
          var newItem = {'id': variantId, 'quantity': 1};
          items.push(newItem);
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { items: items },
            success: function() {
              thewrongshop.refreshCart();
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              thewrongshop.refreshCart();
            }
          });
          return false;
        });
      },

      productFramingGuide: function() {
        if($(".js-open-framing-guide").length > 0) {
          var url = $(".js-open-framing-guide").attr("href");
          $('#get-framing-guide-content').load('' + url + ' #framing-guide-content', function() {
            $("#get-framing-guide-content .js-video-lightbox").appendTo("body");
          });
        }
        $(".js-open-framing-guide").click(function () {
          $("body").css("overflow", "hidden");
          $(".js-framing").addClass("active");
          setTimeout(function () {
            $(".js-framing").addClass("show");
          }, 100);
          return false;
        });
        $("body").on("click", ".js-close-framing", function() {
          $(".js-framing").removeClass("active");
          $(".js-framing").removeClass("show");
          $("body").css("overflow", "visible");
          return false;
        });
      },

      // Pages
      pageDelivery: function() {
        $(".js-page-content table").wrap("<div class='table-responsive'></div>");
      },

      blog: function() {
        $("body").on("click", ".js-blog-next-page", function () {
          var href = $(this).attr("data-href");
          $(".js-blog-next-page").html($(".js-blog-next-page").attr("data-loading-text"));
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $(".js-blog-action").remove();
            $('.js-blog-row').append($(data).find('.js-blog-row').html());
          })
          return false;
        });
        $(".js-blog-tag-page").each(function () {
          var that = $(this);
          var href = $(this).attr("data-href");
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            var counter = $(data).find('.js-blog').attr("data-articles-count");
            $(that).find("span").html("[" + counter + "]");
          })
        });
        $(".js-blog-tag-page").click(function () {
          $(".js-blog-tag-page").removeClass("active");
          $(this).addClass("active");
          var href = $(this).attr("data-href");
          $('.js-blog-row').html('<div class="col-12 article-grid-item">Loading...</div>');
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $('.js-blog-row').html($(data).find('.js-blog-row').html());
          })
          history.pushState({}, "", href);
          return false;
        });
      },

      article: function() {
        $(".js-article-gallery-carousel").owlCarousel({
          margin: 30,
          loop: true,
          autoWidth: true,
          items: 3,
          nav: true,
          responsive: {
            0:{
              margin: 15
            }, 
            992:{
              margin: 30
            }
          }
        })
      },

      about: function () {
        $(".js-feature-3-content").each(function () {
          var padding_bottom = $(this).find(".js-feature-3-description").outerHeight() + 50;
          $(this).css("padding-bottom", padding_bottom);
        });
      },

      framing: function() {
        $(".js-load-all-framing-options").click(function () {
          $(this).parent().remove();
          $(".js-framing-option").removeClass("d-none");
          return false;
        });
        if($(".js-framing-option").length > 0) {
          var url = window.location.href,
              hash = url.split('#')[1];
          if(hash) {
            if($(".js-framing-option[data-anchor-url='#" + hash + "']").length > 0) {
              $(".js-load-all-framing-options").parent().remove();
              $(".js-framing-option").removeClass("d-none");
              var offTop = $(".js-framing-option[data-anchor-url='#" + hash + "']").offset().top - 120;
              $(window).scrollTop(parseInt(offTop));
            }
          }
        }
      },

      contactForm: function() {
        $(".js-submit-contact-form").click(function () {
          $(".js-contact-email").val($(".js-contact-form-email").val());
          $(".js-contact-name").val($(".js-contact-form-name").val());
          $(".js-contact-phone").val($(".js-contact-form-phone-number").val());
          var company = $(".js-contact-form-company").val();
          var country = $(".js-contact-form-country").val();
          var website = $(".js-contact-form-website").val();
          var message = "Company: " + company + "\n";
          message += "Country: " + country + "\n";
          message += "Website: " + website + "\n\n";
          message += "Message: \n";
          message += $(".js-contact-form-message").val();
          $(".js-ask-question-body").val(message);
          $(".js-contact-form form").submit();
          return false;
        });
      },

      // Utilites
      matchHeight: function() {
        $('.js-match-height').matchHeight();
      },

      video: function() {
        $('.js-youtube-video').youtube_background();
        $('.js-vimeo-video').vimeo_player();
        if($('.js-video').length > 0) {
          $(".js-video").each(function () {
            this.controls = false;
            $(this).get(0).play();
          });
        }
        if($(".js-product video").length > 0) {
          $(".js-product video").each(function () {
            this.controls = false;
            $(this).parent().find("video").get(0).play();
          });
        }
      },

      aos: function() {
        AOS.init();
        setInterval(function () {
          $(".aos-init.aos-animate").addClass("animation-done");
        }, 300);
      },

      zoom: function() {
        if($(".js-zoomit").length > 0) {
          setInterval(function () {
            $(".js-zoomit").each(function () {
              if(!$(this).hasClass("active")) {
                if($(this).closest(".js-main-product-zommed-image").hasClass("active") && $(".js-zoomed-images").hasClass("active")) {
                  $(this).attr("src", $(this).attr("data-src")).addClass("active");
                  $(this).imageZoom({zoom : 125});
                }
              }
            });
          }, 100);
          setInterval(function () {
            $(".containerZoom").each(function () {
              var that = $(this);
              if($(this).closest(".js-main-product-zommed-image").hasClass("active")) {
                setTimeout(function () {
                  $(that).addClass("show");
                }, 100);
              } else {
                $(this).removeClass("show");
              }
            });
          }, 100);
        }
      },

      gallery: function() {
        $(".js-popup-gallery a").jqPhotoSwipe({
          forceSingleGallery: true
        });
      },

      accordion: function() {
        $(".js-accordion-title").click(function() {
          $(this).parent().parent().find(".js-accordion").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          $(this).parent().parent().find(".js-accordion:not(.current).active .js-accordion-content").slideToggle(500);
          $(this).parent().parent().find(".js-accordion:not(.current).active").removeClass("active");
          $(this).parent().find(".js-accordion-content").slideToggle(500);
        });
        $(".js-accordion.active").each(function () {
          $(this).find(".js-accordion-content").slideToggle(500);
        });
      },

      refreshCart: function() {
        thewrongshop.upsellCart();
        $('#cart-content').load('/cart #cart-content', function() {
          $("body").css("overflow", "hidden");
          $(".js-add-to-cart").each(function () {
            $(this).html($(this).attr("data-original-text"));
          });
          $(".js-add-variant-to-cart").each(function () {
            $(this).html($(this).attr("data-original-text"));
          });
          $(".js-cart-content").removeClass("is-loading");
          $(".js-canvas-cart").addClass("active");
          setTimeout(function () {
            $(".js-canvas-cart").addClass("show");
          }, 100);

          // Delivery message
          var country = 'row'; 
          var timezone = localStorage.getItem('timezone2');
          if(timezone.indexOf("Europe") >= 0) {
            country = 'eu';
          }
          if(localStorage.getItem('country2') == 'GB') {
            country = 'uk';
          }
          if(localStorage.getItem('country2') == 'US') {
            country = 'us';
          }
          $(".js-delivery-message:not(.show-for-" + country + ")").remove();
          $(".js-delivery-message").show();

          // Recently viewed
          $(".js-mobile-recently-viewed").html($(".js-recently-viewed").html());
        });
        jQuery.getJSON('/cart.js', function(cart) {
          $('.js-cart-counter').html(cart.item_count);
        });
      },

      videoLightbox: function() {
        $("body").on("click", ".js-open-video", function () {
          var id = $(this).attr("data-video-id");
          $(".js-video-lightbox[data-video-id='" + id + "']").addClass("active");
          setTimeout(function () {
            $(".js-video-lightbox[data-video-id='" + id + "']").addClass("show");
            if($(".js-video-lightbox[data-video-id='" + id + "'] video").length > 0) {
              $(".js-video-lightbox[data-video-id='" + id + "'] video").get(0).play();
            }
          }, 100);
          return false;
        });
        $("body").on("click", ".js-close-video-lightbox", function () {
          $(".js-video-lightbox").removeClass("active").removeClass("show");
          $(".js-video-lightbox video").each(function () {
            $(this).get(0).pause();
          });
          return false;
        });
      },

      upsellCart: function() {
        $(".js-recently-viewed-products").addClass("d-none");
        $(".js-recently-viewed-title").addClass("d-none");
        $(".js-why-not-try-products").removeClass("d-none");
        $(".js-why-not-try-title").removeClass("d-none");
        $(".js-why-not-try-products").html('<span class="loader"></span>');
        var $div = $('<div>');
        jQuery.getJSON('/cart.js', function(cart) {
          for (var i = 0; i < cart.items.length; i++) {
            $div.load(cart.items[i].url + ' #upsell-' + cart.items[i].variant_id, function() { });
          }
          setTimeout(function () {
            $(".js-why-not-try-products").html($div);
            if($(".js-why-not-try-products").find(".product-grid-item-2").length < 1) {
              $(".js-recently-viewed-products").removeClass("d-none");
              $(".js-recently-viewed-title").removeClass("d-none");
              $(".js-why-not-try-products").addClass("d-none");
              $(".js-why-not-try-title").addClass("d-none");
            } else {
              $(".js-recently-viewed-products").addClass("d-none");
              $(".js-recently-viewed-title").addClass("d-none");
              $(".js-why-not-try-products").removeClass("d-none");
              $(".js-why-not-try-title").removeClass("d-none");
            }
            $(".js-mobile-recently-viewed .js-why-not-try-products > div .product-grid-item-2").appendTo(".js-mobile-recently-viewed .js-why-not-try-products");
          }, 3000);
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  thewrongshop.init();
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      thewrongshop.init();
    }).on('shopify:section:unload', function() {
      thewrongshop.init();
    }).on('shopify:section:select', function() {
      thewrongshop.init();
    }).on('shopify:section:deselect', function() {
      thewrongshop.init();
    }).on('shopify:block:select', function() {
      thewrongshop.init();
    }).on('shopify:block:deselect', function() {
      thewrongshop.init();
    });
}

document.onkeydown = function(e) {
  switch(e.which) {
    case 37: // left
      $(".js-carousel-nav-previous").click()
    break;

    case 39: // right
      $(".js-carousel-nav-next").click();
    break;

    default: return; // exit this handler for other keys
  }
  e.preventDefault(); // prevent the default action (scroll / move caret)
};